/***
 * www.mohela.com TypeScript Entry Point
 * @author Arthur Moore <ArthurMO@mohela.com>
 * @copyright MOHELA 2023
 ***/

import 'main.ts';  // Bug means that root level items need their extension
import './app.scss';

console.log("www")
